import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"

const TabsContext = createContext({})

export function Tabs({ children }) {
  const isInitialized = useRef(false)
  const inventory = useRef({
    tabs: [],
    tabPanels: [],
  })
  const [key, setKey] = useState()
  return React.createElement(
    TabsContext.Provider,
    { value: { isInitialized, inventory, key, setKey } },
    typeof children === "function" ? children({ key, setKey }) : children,
  )
}

export const Tab = ({ children, tabKey }) => {
  const { isActive, onClick } = useTab(tabKey)

  if (!isActive) {
    return null
  }

  return children
}

export const TabPanel = ({ children, tabKey }) => {
  const { isActive } = useTabPanel(tabKey)

  if (!isActive) {
    return null
  }

  return children
}

export const useTab = (tabKey) => {
  const { isInitialized, inventory, key, setKey } = useContext(TabsContext)
  const [internalKey] = useState(() => {
    const length = inventory.current.tabs.push(
      tabKey !== null && tabKey !== void 0
        ? tabKey
        : inventory.current.tabs.length + 1,
    )
    return tabKey !== null && tabKey !== void 0 ? tabKey : length
  })
  useEffect(() => {
    if (!isInitialized.current) {
      isInitialized.current = true
      setKey(internalKey)
    }
    return () => {
      const keyIndex = inventory.current.tabs.indexOf(internalKey)
      inventory.current.tabs.splice(keyIndex, 1)
      if (inventory.current.tabs.length === 0) {
        isInitialized.current = false
      }
      setKey((key) => {
        var _a
        if (key !== internalKey) {
          return key
        }
        return inventory.current.tabs.length > 0
          ? (_a = inventory.current.tabs[keyIndex]) !== null && _a !== void 0
            ? _a
            : inventory.current.tabs[inventory.current.tabs.length - 1]
          : undefined
      })
    }
  }, [])
  return {
    isActive: key === internalKey,
    onClick: () => setKey(internalKey),
    setKey,
  }
}

export const useTabPanel = (tabKey) => {
  const { inventory, key, setKey } = useContext(TabsContext)
  const [internalKey] = useState(() => {
    const length = inventory.current.tabPanels.push(
      tabKey !== null && tabKey !== void 0
        ? tabKey
        : inventory.current.tabPanels.length + 1,
    )
    return tabKey !== null && tabKey !== void 0 ? tabKey : length
  })
  useEffect(() => {
    return () => {
      inventory.current.tabPanels.splice(
        inventory.current.tabPanels.indexOf(internalKey),
        1,
      )
    }
  }, [])
  return {
    isActive: key === internalKey,
    setKey,
  }
}
